// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__2iFfl","Header":"Category_Header__2q6H5","Opened":"Category_Opened__3GMYH","Closed":"Category_Closed__1t2Mb","Wrap":"Category_Wrap__29irv"};